import { GridColumnHeaderParams } from '@mui/x-data-grid-pro';
import HeightIcon from '@mui/icons-material/Height';
import * as React from 'react';

const GenericTableHeader: React.FC<{
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}> = ({ children, className, style }) => {
  return (
    <div
      className={`w-full h-8 flex items-center justify-center absolute border-r border-blue-300 overflow-hidden bg-blue-100 ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};
GenericTableHeader.displayName = 'GenericTableHeader';

export const TableHeader: React.FC<GridColumnHeaderParams> = (params) => {
  return (
    <GenericTableHeader>
      <h6 className="uppercase font-bold">{params.colDef.headerName}</h6>
    </GenericTableHeader>
  );
};
TableHeader.displayName = 'TableHeader';

export const HoldsTableHeader: React.FC<GridColumnHeaderParams> = (params) => {
  return (
    <GenericTableHeader style={{ right: '-1px' }}>
      <h6 className="uppercase font-bold">{params.colDef.headerName}</h6>
      {/* TODO: Make this a functional button */}
      <div className="absolute w-4 h-full shadow-l flex items-center justify-center right-0">
        <HeightIcon style={{ transform: 'rotate(90deg)', fontSize: 10 }} />
      </div>
    </GenericTableHeader>
  );
};
HoldsTableHeader.displayName = 'HoldsTableHeader';
